import { useForm, isNotEmpty } from '@mantine/form';

import { useShowResponseStatus, useAppSelector, selectCurrencies } from '@/shared';
import { useUpdateWithdrawalMethodMutation } from '../store/withdrawal-methods-api';

import type { TWithdrawalMethodUpdateParams, TWithdrawalMethod } from '../store/types';

type FormData = TWithdrawalMethodUpdateParams;

type Params = {
  withdrawalMethod: TWithdrawalMethod;
  onClose?: () => void;
};

export const useUpdateWithdrawalMethod = ({ withdrawalMethod, onClose }: Params) => {
  const avalableCurrencies = useAppSelector(selectCurrencies);

  const [updateWithdrawalMethod, {
    isLoading,
    isSuccess,
    isError,
  }] = useUpdateWithdrawalMethodMutation();

  const initialValues: FormData = {
    methodId: withdrawalMethod.id,
    name: withdrawalMethod.name,
    currency: withdrawalMethod.currency,
    minAmount: withdrawalMethod.minAmount,
    maxAmount: withdrawalMethod.maxAmount,
    withdrawalPercent: withdrawalMethod.withdrawalPercent,
    withdrawalFee: withdrawalMethod.withdrawalFee,
    active: withdrawalMethod.active,
  };

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues,
    validate: {
      methodId: (value) => !value ? 'Обязательное поле' : null,
      name: isNotEmpty('Введите имя'),
      currency: isNotEmpty('Выберите валюту'),
      minAmount: (value) => !value ? 'Введите минимальную сумму' : null,
      maxAmount: (value) => !value ? 'Введите максимальную сумму' : null,
      withdrawalPercent: (value) => !value ? 'Введите процент вывода' : null,
      withdrawalFee: (value) => !value ? 'Введите фикс' : null,
    },
  });

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Метод вывода успешно изменён',
    isError,
    errorMassage: 'При изменении метода вывода произошла ошибка',
  });

  const handleSubmit = async (values: FormData) => {
    // console.log('create values:', values);
    await updateWithdrawalMethod(values);
    onClose?.();
  };

  return {
    avalableCurrencies,
    form,
    isLoading,
    handleSubmit,
  };
};
